module.exports = __webpack_public_path__ + "static/img/cDR8.d471c526.png";